module.exports = __webpack_public_path__ + "static/media/empty-set.40a8ec92.png";